<template>
  <div class="dl-panel" v-if="tasks.length">
    <div class="dl-head">
      <span>下载</span>
      <span class="dl-count">{{ tasks.length }}</span>
    </div>
    <div class="dl-list">
      <div class="dl-item" v-for="task in tasks" :key="task.id">
        <div class="dl-row">
          <span class="dl-name" :title="task.name">{{ task.name }}</span>
          <a class="dl-close" @click="closeTask(task)">{{ task.status === 'downloading' ? '取消' : '关闭' }}</a>
        </div>
        <div class="dl-bar">
          <div class="dl-bar-inner" :class="barClass(task)" :style="{ width: barWidth(task) }"></div>
        </div>
        <div class="dl-meta" :class="{ 'dl-meta-error': task.status === 'error' }">{{ metaOf(task) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { subscribe, removeTask } from './downloadManager.js'

export default {
  name: 'downloadTaskPanel',
  data: function () {
    return {
      tasks: []
    }
  },
  mounted: function () {
    var that = this
    this.unsubscribe = subscribe(function (list) {
      that.tasks = list
    })
  },
  beforeDestroy: function () {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    closeTask: function (task) {
      removeTask(task.id)
    },
    barWidth: function (task) {
      if (task.status === 'done' || task.status === 'browser') return '100%'
      if (task.status === 'error' || task.status === 'cancelled') return '100%'
      if (!task.total) return '30%'
      var percent = task.percent || 0
      if (percent < 0) percent = 0
      if (percent > 100) percent = 100
      return percent + '%'
    },
    barClass: function (task) {
      if (task.status === 'done' || task.status === 'browser') return 'is-done'
      if (task.status === 'error') return 'is-error'
      if (task.status === 'cancelled') return 'is-cancel'
      if (!task.total) return 'is-unknown'
      return ''
    },
    metaOf: function (task) {
      if (task.status === 'error') return task.message || '下载失败'
      if (task.status === 'cancelled') return '已取消'
      if (task.status === 'browser') return task.message || '进度在浏览器下载列表里'
      if (task.status === 'done') return '已完成 ' + this.formatSize(task.total || task.received)
      if (!task.total) return '已下载 ' + this.formatSize(task.received)
      return (task.percent || 0) + '%  ' + this.formatSize(task.received) + ' / ' + this.formatSize(task.total)
    },
    formatSize: function (size) {
      var n = Number(size) || 0
      if (n < 1024) return n + ' B'
      if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB'
      if (n < 1024 * 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + ' MB'
      return (n / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    }
  }
}
</script>

<style scoped>
.dl-panel {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 2000;
  width: 320px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.dl-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  padding: 0 12px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  font-weight: 600;
  color: #262626;
}
.dl-count {
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: #1890ff;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  font-weight: 500;
}
.dl-list {
  max-height: 280px;
  overflow: auto;
  padding: 8px 12px 10px;
}
.dl-item + .dl-item {
  margin-top: 10px;
}
.dl-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dl-name {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-close {
  flex-shrink: 0;
  font-size: 12px;
  color: #1890ff;
}
.dl-bar {
  height: 6px;
  margin-top: 6px;
  border-radius: 3px;
  background: #f5f5f5;
  overflow: hidden;
}
.dl-bar-inner {
  height: 100%;
  background: #1890ff;
  border-radius: 3px;
  transition: width 0.2s linear;
}
.dl-bar-inner.is-done {
  background: #52c41a;
}
.dl-bar-inner.is-error {
  background: #ff4d4f;
}
.dl-bar-inner.is-cancel {
  background: #d9d9d9;
}
.dl-bar-inner.is-unknown {
  width: 30% !important;
  animation: dl-slide 1.2s ease-in-out infinite;
}
.dl-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.4;
}
.dl-meta-error {
  color: #ff4d4f;
}
@keyframes dl-slide {
  0% { transform: translateX(-120%); }
  100% { transform: translateX(360%); }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/downloadTaskPanel.vue